import { useState } from "react";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./HelpModal.module.css";

// Slide content for home visualizer help
const slides = [
    {
        id: "welcome",
        title: "Home Visualizer Help",
        image: null,
        content:
            "Learn how to design your dream home. Click Start to begin the walkthrough.",
        isWelcome: true
    },
    {
        id: "get-started",
        title: "Get Started or Log In",
        image: "/help/get-started.jpg",
        content: (
            <>
                Select the <strong>GET STARTED</strong> button to begin or the <strong>LOG IN</strong> button to open saved projects
            </>
        )
    },
    {
        id: "select-floorplan",
        title: "Choose a Floor Plan",
        image: "/help/select-floorplan.jpg",
        content: (
            <>
                <strong>STEP 1:</strong> Filter all floors plans from the drop down menus. <br/>
                <strong>STEP 2:</strong> Choose a plan
            </>
        )
    },
    {
        id: "filter-plan",
        title: "Filter Plan",
        image: "/help/filter-plans.jpg",
                content: (
            <>
                Filter your floor plan by: <br/>
                <strong>STEP 1:</strong> Select a community <br/>
                <strong>STEP 2:</strong> Choose an elevation <br/>
                <strong>STEP 3:</strong> Choose a floor plan scene
            </>
        )
    },
    {
        id: "steps",
        title: "Navigate Steps",
        image: "/help/steps.jpg",
        content: (
            <>
                Cycle through the product menus using the <strong>Previous and Next Arrows </strong>at the top of the product panel.
            </>
        )
    },
    {
        id: "applied",
        title: "Applied Menu",
        image: "/help/applied.jpg",
        content: (
            <>
                Select the <strong>View All Applied</strong> link to view selected products
            </>
        )
    },
    {
        id: "switch-rooms",
        title: "Switch Rooms",
        image: "/help/switch-rooms.jpg",
        content: "Switch between different rooms by clicking on the room thumbnails on the right side panel."
    },
    {
        id: "save-project",
        title: "Save Project /  My Projects",
        image: "/help/save-project.jpg",
        content: "Click Save or My Projects in the top menu to save your design progress or open a previous project."
    },
    {
        id: "menu",
        title: "Main Menu ☰",
        image: "/help/menu.jpg",
        content: (
            <>
                Use the navigation to access tools like{" "}
                <strong>Start Over, My Project, Save, Feedback, Help, Share, Print/PDF.</strong>
            </>
        )
    },
    {
        id: "extras",
        title: "Share & Print",
        image: "/help/extras.jpg",
        content: "Use the Share button to send your design via email or social media. Use Print to create a PDF of your selections."
    }
];

export default function HelpModal({ isOpen, onClose }) {
    const [currentSlide, setCurrentSlide] = useState(0);

    if (!isOpen) return null;

    const handleClose = () => {
        setCurrentSlide(0); // reset tutorial
        onClose();
    };

    const handleStart = () => setCurrentSlide(1);

    const handleNext = () => {
        if (currentSlide < slides.length - 1) {
            setCurrentSlide((prev) => prev + 1);
        }
    };

    const handlePrev = () => {
        if (currentSlide > 0) {
            setCurrentSlide((prev) => prev - 1);
        }
    };

    const slide = slides[currentSlide];
    const isFirstSlide = currentSlide === 0;
    const isLastSlide = currentSlide === slides.length - 1;

    return (
        <PopUpModal
            handleClose={handleClose}
            size="medium"
            title="Help Guide"
            ariaLabelledBy="help-modal-title"
        >
            <div className={styles.mainContent}>
                <div className={styles.slideContainer}>
                    <div className={styles.slideContent}>
                        <h3
                            id="help-modal-title"
                            className={styles.slideTitle}
                        >
                            {slide.title}
                        </h3>

                        {slide.image && (
                            <div className={styles.slideImageContainer}>
                                <img
                                    src={slide.image}
                                    alt={slide.title}
                                    className={styles.slideImage}
                                />
                            </div>
                        )}

                        <p className={styles.slideText}>
                            {slide.content}
                        </p>
                    </div>

                    <div className={styles.slideNavigation}>
                        {isFirstSlide ? (
                            <button
                                className={styles.startButton}
                                onClick={handleStart}
                            >
                                Start
                            </button>
                        ) : (
                            <>
                                <button
                                    className={styles.navButton}
                                    onClick={handlePrev}
                                >
                                    Previous
                                </button>

                                {isLastSlide ? (
                                    <button
                                        className={styles.finishButton}
                                        onClick={handleClose}
                                    >
                                        Finish
                                    </button>
                                ) : (
                                    <button
                                        className={styles.navButton}
                                        onClick={handleNext}
                                    >
                                        Next
                                    </button>
                                )}
                            </>
                        )}
                    </div>

                    <div className={styles.slideIndicator}>
                        {currentSlide + 1} / {slides.length}
                    </div>
                </div>
            </div>
        </PopUpModal>
    );
}
